import axios from 'axios';
import { Tag } from '~/types/models/tags';

export const tagApiPath = '/api/v3/user/tags';

// Create new tag
export interface CreateNewTagArgs {
  name: string;
  color: string;
}

export interface CreateNewTagResponse {
  data: Tag;
}

export async function createNewTag({ name, color }: CreateNewTagArgs) {
  const res = await axios.post<CreateNewTagResponse>(tagApiPath, {
    name,
    color,
  });
  return res.data.data;
}
export interface GetTagsResponse {
  data: Tag[];
}

export async function getTags() {
  const res = await axios.get<GetTagsResponse>(tagApiPath);
  return res.data.data;
}

// Update tags
export interface UpdateTagsArgs {
  updatedTags: Tag[];
}

export interface UpdateTagsResponse {
  data: Tag[];
}

export async function updateTags({ updatedTags }: UpdateTagsArgs) {
  const res = await axios.put<UpdateTagsResponse>(`${tagApiPath}/bulk-update`, {
    tags: updatedTags,
  });
  return res.data;
}

// Delete a tag
export interface DeleteTagArgs {
  tag: Tag;
}

export interface DeleteTagResponse {
  message: string;
}

export async function deleteTag({ tag }: DeleteTagArgs) {
  const res = await axios.delete<DeleteTagResponse>(
    `${tagApiPath}/${tag.uuid}`
  );
  return res.data;
}
